export default class ScoreTypeHelper {
  constructor (data) {
    this.id = data.id
    this.disciplineId = data.disciplineId
    this.eventUnitId = data.eventUnitId
    this.roundTypeId = data.roundTypeId
    this.scoreTypeId = data.scoreTypeId
  }
}
